/* globals Calendly */
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'

import {CALENDLY_URL} from '../../../constants/routes'

class RequestDemoButton extends Component {
  static propTypes = {
    buttonComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    url: PropTypes.string,
    onClick: PropTypes.func,
    locationNameForAnalytics: PropTypes.string,
    children: PropTypes.node.isRequired,
  }

  static defaultProps = {
    url: CALENDLY_URL,
    onClick: null,
    locationNameForAnalytics: undefined,
  }

  handleClick = () => {
    const {onClick, url, locationNameForAnalytics} = this.props

    if (locationNameForAnalytics) {
      // GTM event
      const dataLayer = window?.dataLayer ?? []
      dataLayer.push({
        event: 'talk_to_us',
        location: locationNameForAnalytics,
      })
    }

    if (onClick) onClick()
    Calendly.showPopupWidget(url)
  }

  render() {
    const {buttonComponent: Button, onClick, children, ...restProps} = this.props
    return (
      <>
        <Helmet>
          <script src="/static/calendly.js" type="text/javascript" async />
          <link href="/static/calendly.css" rel="stylesheet" />
        </Helmet>
        <Button onClick={this.handleClick} data-target="request-demo" {...restProps}>
          {children}
        </Button>
      </>
    )
  }
}

export default RequestDemoButton
